module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "folder"
  }, [_c('VueLabel', {
    attrs: {
      "isFolder": "true",
      "isRoot": _vm.isRoot,
      "Key": _vm.Key,
      "Name": _vm.folderData[_vm.Key].Title,
      "path": _vm.path,
      "canEdit": _vm.canEdit
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isChecked),
      expression: "isChecked"
    }],
    staticClass: "folderCheck",
    attrs: {
      "type": "checkbox",
      "id": 'folder' + _vm.Key
    },
    domProps: {
      "checked": Array.isArray(_vm.isChecked) ? _vm._i(_vm.isChecked, null) > -1 : (_vm.isChecked)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.isChecked,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.isChecked = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.isChecked = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.isChecked = $$c
        }
      }
    }
  }), _vm._v(" "), _vm._l((_vm.subFolders), function(folder, index) {
    return _c('Folder', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.isChecked),
        expression: "isChecked"
      }],
      attrs: {
        "Key": Object.keys(folder)[0],
        "path": folder.Path,
        "folderData": folder,
        "canEdit": _vm.canEdit
      }
    })
  }), _vm._v(" "), _vm._l((_vm.files), function(file, index) {
    return _c('VueLabel', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.isChecked),
        expression: "isChecked"
      }],
      staticClass: "file",
      attrs: {
        "isFile": "true",
        "Key": file.Key,
        "path": file.Path,
        "Name": file.Title,
        "Url": file.Url,
        "canEdit": _vm.canEdit
      }
    })
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-574ef595"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Folder.vue
// module id = 893
// module chunks = 2